export const MIXTURE_TANK_IMAGES = {
	empty: '/images/caixa-fundo-vazio.png',
	full: '/images/caixa-cheia.png',
} as const;

export const MIXTURE_PRODUCT_COLOR_COUNT = 3;

export const MIXTURE_PAGE_SIZE = 10;

export const MIXTURE_CUSTOM_DAY_FILTER = 'day:custom';

export const MIXTURE_SETTINGS_FIELDS = [
	{ key: 'vbox', label: 'Volume da caixa de injeção', unit: 'L', placeholder: 'Ex.: 1000' },
	{
		key: 'totalInjectionTime',
		label: 'Tempo total de injeção',
		unit: 'min',
		placeholder: 'Ex.: 30',
	},
	{
		key: 'totalOperationTime',
		label: 'Tempo total de operação',
		unit: 'min',
		placeholder: 'Ex.: 30',
	},
	{ key: 'cemMax', label: 'Concentração salina máxima', unit: 'g/L', placeholder: 'Ex.: 2,5' },
	{
		key: 'desiredEventsPerMonth',
		label: 'Nº desejado de irrigações mensais',
		unit: '',
		placeholder: 'Ex.: 4',
		optional: true,
	},
] as const;

export type MixtureSettingsField = (typeof MIXTURE_SETTINGS_FIELDS)[number]['key'];

export type MixtureSettingsForm = Record<MixtureSettingsField, string>;

export const EMPTY_MIXTURE_SETTINGS_FORM: MixtureSettingsForm = {
	vbox: '',
	totalInjectionTime: '',
	totalOperationTime: '',
	cemMax: '',
	desiredEventsPerMonth: '',
};

export const MIXTURE_STATUS_LABELS = {
	generated: 'Sugerida pelo sistema',
	manual: 'Adicionada manualmente',
	confirmed: 'Verificada',
} as const;

export const MIXTURE_PENDING_LABEL = 'Pendente';
